/**
 *
 * MainModeCourseCpnt
 *
 */

import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';

import Chart from 'chart.js';

import StudentworkModal from '@/components/StudentworkModal.vue';

export default {
  name: 'MainModeCourseCpnt',

  components: {
    StudentworkModal,
  },

  data: () => {
    return {
      promiseGetCourse: null,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapGetters({
      Course: 'MainModeCourse/Course',
      Books: 'MainModeCourse/Books',
      UnissuedBooks: 'MainModeCourse/UnissuedBooks',
    }),

    ...mapGetters('MainModeCourse', {
      mg_myTaskStatus: 'myTaskStatus',
    }),

    c_courseId() {
      return this.$route.params.courseId;
    },

    _c_pagePrefix() {
      return `/course/${this.c_courseId}`;
    },

    c_challengeModePage() {
      return `${this._c_pagePrefix}/challenge-mode`;
    },

    c_videoModeCoursePage() {
      return `${this._c_pagePrefix}/video-mode`;
    },

    c_liveModeCoursePage() {
      return `${this._c_pagePrefix}/live-mode`;
    },

    SortedBooks: function () {
      return this.Books
        ? [...this.Books].sort((v1, v2) => v2.bookLevel - v1.bookLevel).filter((v) => !v.otherBook)
        : [];
    },

    SortedUnissuedBooks: function () {
      return this.UnissuedBooks ? this.UnissuedBooks.filter((v) => !v.otherBook) : [];
    },

    c_allSortedBooks() {
      const sortedBooks = _.map(this.SortedBooks, (book) => ({
        ...book,
        i_isIssued: true,
      }));
      const sortedUnissuedBooks = _.map(this.SortedUnissuedBooks, (book) => ({
        ...book,
        i_isIssued: false,
      }));
      return [...sortedBooks, ...sortedUnissuedBooks];
    },
  },

  methods: {
    gotoPlan() {
      this.$router.push(`/career/${this.Course.planInfo.planId}`);
    },

    gotoTrainingCamps() {
      this.$router.push(`/training-camps/${this.c_courseId}`);
    },

    async _MainModeCourseCpntMounted() {
      this.promiseGetCourse = window.promiseGetCourse;
      await this.promiseGetCourse;
      const ctx = this.$refs.pzChart;
      if (ctx) {
        new Chart(ctx, {
          type: 'doughnut',
          data: {
            datasets: [
              {
                data: [
                  this.Course.courseAnalysis.countLevel0,
                  this.Course.courseAnalysis.countLevel1,
                  this.Course.courseAnalysis.countLevel2,
                  this.Course.courseAnalysis.countLevel3,
                  this.Course.courseAnalysis.countLevel4,
                ],
                backgroundColor: ['#EBEDF0', '#E5B3FF', '#D480FF', '#AA00FF', '#7C00BA'],
              },
            ],
            labels: ['未开始', '练习中', '初步了解', '熟悉', '精通'],
          },
          options: {
            responsive: true,
            legend: {
              display: false,
              position: 'top',
            },
            tooltips: {
              enabled: false,
            },
            cutoutPercentage: 80,

            animation: {
              animateScale: true,
              animateRotate: true,
            },
          },
        });
      }
    },
  },

  mounted() {
    this._MainModeCourseCpntMounted();
  },
};
